import { YDate } from './date-methods';
import { YString } from './string-methods';

const yup = { ...YDate, ...YString };

export { yup };
